import { withDevtools, withGlitchTracking } from '@angular-architects/ngrx-toolkit';
import { computed } from '@angular/core';
import { initialVesselReportsState } from '@navstation-portal/reporting/data-model/vessel-reports';
import { ReducedVesselReport } from '@navstation-portal/reporting/data-model/vessel-reports';
import { signalStore, withComputed, withState } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';
import { buildVesselReportsVm } from './vessel-reports-vm-builder';
import { withVesselReportsEffects } from './with-vessel-reports-effects';
import { withVesselReportsReducer } from './with-vessel-reports-reducer';

export const VesselReportsStore = signalStore(
  { providedIn: 'root' },
  withDevtools('VesselReportsStore', withGlitchTracking()),
  withState(initialVesselReportsState),
  withEntities<ReducedVesselReport>(),
  withVesselReportsEffects(),
  withVesselReportsReducer(),
  withComputed((store) => ({
    vm: computed(() => {
      const reports = store.entities();
      return buildVesselReportsVm(reports);
    }),
  }))
);
